"use strict";
exports.__esModule = true;
exports.singleLine = exports.warn = exports.error = void 0;
var red = "\u001b[31m ";
var yellow = "\u001b[33m ";
var reset = "\u001b[0m ";
var error = function (message) {
    throw new Error("".concat(red, "\nCULTUREAMP UI ERROR:\n").concat((0, exports.singleLine)(message)).concat(reset, "\n"));
};
exports.error = error;
var warn = function (message) {
    // eslint-disable-next-line no-console
    console.warn("".concat(yellow, "\nCULTUREAMP UI WARNING:\n").concat((0, exports.singleLine)(message)).concat(reset, "\n"));
};
exports.warn = warn;
var singleLine = function (message) {
    return message.replace(/^ +/gm, " ").replace(/\n|\r/gm, "").trim();
};
exports.singleLine = singleLine;
//# sourceMappingURL=console.js.map